import React, { Suspense } from "react";
import { ApolloProvider } from "@apollo/client";
import isKioskMode from "../../libs/isKioskMode";
import createClient from "../../graphql/createClient";
import { getCompanyIdFromCookies } from "../../libs/cookies/companyId";

const WebApp = React.lazy(() => import("./WebApp/WebApp"));
const KioskApp = React.lazy(() => import("./KioskApp/KioskApp"));
const CompanySelection = React.lazy(() => import("./CompanySelection/CompanySelection"));

const client = createClient();

export default function App() {
  const companyId = getCompanyIdFromCookies();

  return (
    <Suspense fallback={<div>...</div>}>
      <ApolloProvider client={client}>
        {!companyId && <CompanySelection />}
        {companyId && (
          <>
            {isKioskMode() && <KioskApp />}
            {!isKioskMode() && <WebApp />}
          </>
        )}
      </ApolloProvider>
    </Suspense>
  );
}
